import { aigcFormStore } from '@/components/aigc-form/store';
import { sendBroadcast } from '@/hooks/useBroadcast';
import { asyncDownload } from '@/utils/async-download';
import { RepaintCanvasStore } from './repaint/store';
import { EraseCanvasStore } from './erase/store';
import { request } from '@src/common';
import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import userStore from '@/store/user';
import { GenerateImageStore } from '@/pages/generate-image/store';
import stateStore from '../square-video/state-store';
import appLogger from '@public/log/monitor';
import sharpenStore from '@/pages/modify-image/sharpen/store';
import MarketingStore from '@/store/marketing';
import mattingStore from '@/pages/modify-image/matting/store';
import expandStore from '@/pages/modify-image/expand/store';

export const OperationTypeMap = {
  expand: 'expand',
  'super-res': 'sharpen',
  'obj-extract': 'matting',
  redraw: 'repaint',
  eliminate: 'erase',
};
export const logArrts = {
  expand: 'expand',
  sharpen: 'upscale',
  matting: 'cutout',
  repaint: 'redraw',
  erase: 'remove',
};
export const getToolbarList = () => {
  return [
    {
      title: '图生图',
      icon: 'work-img2img',
      action: 'toImage',
    },
    {
      title: '扩图',
      icon: 'modify-expand-icon',
      action: 'expand',
    },
    {
      title: '擦除',
      icon: 'modify-erase-icon',
      action: 'erase',
    },
    {
      title: '区域重绘',
      icon: 'modify-repaint-icon',
      action: 'repaint',
    },
    {
      title: '变清晰',
      icon: 'modify-sharpen-icon',
      action: 'sharpen',
    },
    {
      title: 'AI抠图',
      icon: 'modify-matting-icon',
      action: 'matting',
    },
  ];
};

export const namiCoinType = {
  expand: 'imgedit_expand',
  sharpen: 'imgedit_super-res',
  matting: 'imgedit_obj-extract',
  repaint: 'imgedit_redraw',
  erase: 'imgedit_eliminate',
}

class Store {
  constructor() {
    makeAutoObservable(this);
    this.initTaskList('init');
    this.getNamiUseNum();
    this.getMemberBenefits();
  }

  taskType: string = 'image_image';
  taskList: any[] = [];
  activeTaskId: string | null = '';
  imageResult: any = null;
  page: number | string = '';
  pageSize: number = 20;
  hasMore: boolean = true;
  taskLoading: boolean = false;
  // 存储轮询处理器的引用，用于取消轮询
  pollingTimer: number | null = null;
  // 存储正在轮询的任务ID集合
  pollingTaskIds: Set<string> = new Set();
  // 上次提示的任务ID，用于避免重复提示
  lastNotifiedTaskId: string | null = null;
  activeImgIndex: number = 0;
  taskListVisible: boolean = true;
  // 剩余次数
  // remaining: number = 0;
  // 历史活动任务
  historyActiveTask: any = {};
  compareMode: boolean = false;
  source: string = '';
  nanoCoinList = [];

  setSource = val => {
    this.source = val;
  };
  setCompareMode = mode => {
    this.compareMode = mode;
  };

  // 获取会员配置 在生图对象上设置 （loading组件使用生图数据）
  getMemberBenefits = () => {
    request
      .get('/img/vip/config?appsource=so&device_platform=Web')
      .then(res => {
        const isMember = userStore?.membershipInfo?.is_member;
        const { cost, member_cost } = res.data.map.nano_consume_baseline;
        const configInfo = {
          namiCost: isMember ? member_cost : cost,
          expresswayUsable: res.data.map.expressway_usable,
          noWatermarkUsable: res.data.map.no_watermark_usable,
        };
        GenerateImageStore.setMemberBenefits(configInfo);
      });
  };

  setTaskListVisible = (v?: boolean) => {
    if (typeof v === 'boolean') {
      this.taskListVisible = v;
    } else {
      this.taskListVisible = !this.taskListVisible;
    }
  };

  getNamiUseNum = () => {
    request
      .get('/config/cloud?appsource=so', {
        params: {
          key: 'nano_coin_config',
        },
      })
      .then(res => {
        this.nanoCoinList =  res.data.nano_coin_config.list;
      });
  };

  handleAction = (action, ext2?: number) => {
    const path = window.location.pathname;
    const segments = path.split('/').filter(Boolean);
    const formType = segments.pop();
    const types = {
      toVideo: 'to_video',
      toImage: 'image_image',
      expand: 'expand',
      cutout: 'matting',
      repaint: 'redraw',
      erase: 'remove',
      matting: 'cutout',
      sharpen: 'upscale',
      download: 'download',
    };
    console.log('action', action);
    appLogger.log({
      key: 'aibot_photo_edit',
      action: 'click',
      arrt: logArrts[formType],
      type: types[action],
      task_id: this.activeTask?.biz_id,
      ext2: ext2 || 0,
      ext3: 'resultarea',
    });
    const url = JSON.parse(this.imageResult?.out_images_w || [])[
      this.activeImgIndex
    ].url;
    const toVideoUrl = JSON.parse(this.imageResult?.out_images || [])[
      this.activeImgIndex
    ].url;

    if (action === 'download') {
      let filename = 'download';
      try {
        filename = url.split(/[?#]/)[0].split('/').slice(-1)[0];
      } catch (error) {}
      asyncDownload(url);
      return;
    }
    this.setActiveTask(null, action);
    this.setHistoryActiveTask(action, null);
    if (action === 'toImage') {
      aigcFormStore.setForm('image_public', { image: toVideoUrl });
      stateStore.setLocation('/generate/image?form_type=image_image');
      return;
    }
    if (action === 'toVideo') {
      // 通知营销云
      if (MarketingStore.isMarketingCloud) {
        MarketingStore.pageChange('/generate/video');
      }
      aigcFormStore.setForm('video_public', { img1: toVideoUrl });
      stateStore.setLocation('/generate/video?form_type=image_video');
    } else if (getToolbarList().find(item => item.action === action)) {
      switch (action) {
        case 'repaint':
          RepaintCanvasStore.setRepaintForm({
            refer_img: url,
          });
          break;
        case 'erase':
          EraseCanvasStore.setEraseForm({
            refer_img: url,
          });
          break;
        case 'expand':
          expandStore.setImgUrl(url);
          break;
        case 'sharpen':
          sharpenStore.setImgUrl(url);
          break;
        case 'matting':
          mattingStore.setImgUrl(url);
          break;
      }
      stateStore.setLocation(`/generate/image/${action}?img_source=tool`);
    }
  };

  setHistoryActiveTask = (formType, val) => {
    this.historyActiveTask[formType] = val;
  };

  // refreshRemainingCounts = async () => {
  //   // 调用 aigcFormStore 刷新剩余次数
  //   try {
  //     this.remaining = undefined;
  //     const remaining = await aigcFormStore.fetchRemainingCounter('image');
  //     runInAction(() => {
  //       this.remaining = remaining;
  //     });
  //   } catch (error) {
  //     console.error('获取剩余次数失败:', error);
  //   }
  // };

  setActiveImgIndex = index => {
    this.activeImgIndex = index;
  };

  clearImageResult = () => {
    this.imageResult = null;
    this.activeTaskId = null;
  };

  // 设置活动任务
  setActiveTask = (item, formType) => {
    if (!item) {
      this.activeTaskId = null;
      this.imageResult = null;
      return;
    }

    runInAction(() => {
      this.activeTaskId = item.id_str;
      this.historyActiveTask[formType] = item.id_str;
      // 解析并设置视频结果
      if (item.data) {
        try {
          this.imageResult = JSON.parse(item.data);
        } catch (e) {
          console.error('解析任务数据失败:', e);
          this.imageResult = null;
        }
      } else {
        this.imageResult = null;
      }
    });
  };

  // 基于activeTaskId更新videoResult
  updateVideoResultFromActiveTask = () => {
    if (!this.activeTaskId) {
      this.imageResult = null;
      return;
    }

    const activeTask = this.taskList.find(
      task => task.id_str === this.activeTaskId
    );
    if (activeTask && activeTask.data) {
      try {
        this.imageResult = JSON.parse(activeTask.data);
      } catch (e) {
        console.error('解析任务数据失败:', e);
        this.imageResult = null;
      }
    } else {
      this.imageResult = null;
    }
  };

  // 获取当前选中的任务
  get activeTask() {
    return (
      this.taskList.find(item => item.id_str === this.activeTaskId) || null
    );
  }

  // 重试任务
  onRetry = item => {
    // 更新任务状态为进行中
    this.updateTaskStatus(item.id_str, 1);
    request
      .post(
        '/img/submit?appsource=so&device_platform=Web',
        { biz_id: item.biz_id },
        {
          // @ts-ignore
          dataIsJson: true,
        }
      )
      .then(res => {
        // 将任务添加到轮询列表
        this.pollingTaskIds.add(item.id_str);

        // 如果当前没有轮询在进行，启动轮询
        if (this.pollingTimer === null) {
          this.pollTasksStatus();
        } else {
          // 如果已有轮询在进行，确保此任务被包含在轮询中
          this.startPollingTasks();
        }
      })
      .catch(error => {
        this.updateTaskStatus(item.id_str, 3);
        message.error(error.data || '重试失败，请稍后再试');
      });
  };

  // 删除任务项并自动选择下一个
  deleteTaskItem = async (item, index) => {
    // 从轮询列表中移除任务
    this.pollingTaskIds.delete(item.id_str);
    try {
      // 先调用删除API
      const response = await request.post(
        '/task/delete?appsource=so&device_platform=Web',
        { id_str: item.id_str },
        // @ts-ignore
        { dataIsJson: true }
      );

      if (response.data.result === 'finish') {
        runInAction(() => {
          if (index !== -1) {
            // 创建新数组而不是修改原数组
            this.taskList = [
              ...this.taskList.slice(0, index),
              ...this.taskList.slice(index + 1),
            ];
            // 更新活动项
            this.activeTaskId = null;
            // 根据新的activeTaskId更新videoResult
            this.updateVideoResultFromActiveTask();
          }
        });
        message.success('删除成功');
      }
    } catch (error) {
      message.error('删除失败，请稍后再试');
    }
  };

  // 初始化任务列表
  initTaskList = async (type = 'image_image') => {
    // 重置状态
    this.page = 0;
    this.hasMore = true;
    // this.taskList = [];
    this.taskType = type;
    // this.videoResult = null;
    // this.activeTaskId = null;
    // 取消现有轮询
    this.stopPollingTasks();
    // this.refreshRemainingCounts();
    // 加载第一页数据
    await this.loadMoreTasks('init');

    // 如果有进行中的任务，启动轮询
    if (this.pollingTaskIds.size > 0) {
      this.startPollingTasks();
    }
  };
  // 加载更多数据
  loadMoreTasks = async (type = '') => {
    if (!this.hasMore || this.taskLoading) return;

    this.taskLoading = true;

    try {
      const params: Record<string, string | number | number[] | string[]> = {
        status_list: [1, 2, 3],
        biz_type_list: ['image_image'],
        npt: `${this.page}`,
        page_size: this.pageSize,
        sort_type_list: [104],
      };

      const response = await request.post(
        '/task/list?appsource=so&device_platform=Web',
        params,
        // @ts-ignore
        { dataIsJson: true }
      );
      let newTasks = response.data.list || [];

      runInAction(() => {
        if (newTasks.length === 0) {
          this.hasMore = false;
          if (type === 'init') {
            this.taskList = []
          }
        } else {
          this.taskList =
            type === 'init' ? newTasks : [...this.taskList, ...newTasks];
          this.page = response.data.npt;
          if (!this.page) {
            this.hasMore = false;
          }
          const taskId = this.historyActiveTask[this.taskType] || '';
          const taskItem = this.taskList.find(item => item.id_str === taskId);
          if (this.source !== 'work') {
            if (this.source === 'image') {
              this.setHistoryActiveTask(this.taskType, null);
            } else if (taskItem) {
              this.setActiveTask(taskItem, this.taskType);
            } else {
              this.setActiveTask(undefined, this.taskType);
            }
          } else {
            this.setActiveTask(undefined, this.taskType);
            this.setHistoryActiveTask(this.taskType, null);
          }
          // 检查并添加进行中的任务到轮询列表
          newTasks.forEach(task => {
            if (task.status === 1) {
              this.pollingTaskIds.add(task.id_str);
            }
          });
        }
        this.taskLoading = false;
      });
    } catch (error) {
      console.error('加载更多任务失败', error);
      runInAction(() => {
        this.taskLoading = false;
      });
    }
  };
  // 开始轮询进行中的任务
  startPollingTasks = () => {
    // 先停止之前的轮询
    this.stopPollingTasks();

    if (this.pollingTaskIds.size === 0) {
      return;
    }
    this.pollTasksStatus();
  };

  // 停止轮询
  stopPollingTasks = () => {
    if (this.pollingTimer !== null) {
      clearTimeout(this.pollingTimer);
      this.pollingTimer = null;
    }
  };

  // 轮询任务状态
  pollTasksStatus = async () => {
    if (this.pollingTaskIds.size === 0) {
      // 没有需要轮询的任务
      this.stopPollingTasks();
      return;
    }

    try {
      // 构造批量查询参数
      const taskIds = Array.from(this.pollingTaskIds);

      // 调用批量查询API
      const response = await request.post(
        '/task/list?appsource=so&device_platform=Web',
        {
          id_list_str: taskIds,
          status_list: [1, 2, 3],
          biz_type_list: ['image_image'],
        },
        {
          // @ts-ignore
          dataIsJson: true,
        }
      );

      if (response.data && response.data.list) {
        const taskDetails = response.data.list || [];
        // 用于判断是否有任务状态发生了变化
        let statusChanged = false;
        // 处理返回的任务列表
        taskDetails.forEach(taskDetail => {
          const taskId = taskDetail.id_str;
          const taskStatus = taskDetail.status;

          // 如果任务已完成或失败，更新状态并移除轮询
          if (taskStatus === 2 || taskStatus === 3) {
            statusChanged = true;
            this.updateTaskStatus(taskId, taskStatus, taskDetail);
            this.pollingTaskIds.delete(taskId);
          } else if (taskStatus === 1) {
            this.updateTaskStatus(taskId, taskStatus, taskDetail);
          }
        });
        // if (statusChanged) {
        //   this.refreshRemainingCounts();
        // }
        // 如果还有任务需要轮询，设置下一次轮询
        if (this.pollingTaskIds.size > 0) {
          this.pollingTimer = window.setTimeout(() => {
            this.pollTasksStatus();
          }, 3000); // 每3秒轮询一次
        }
      } else {
        // 即使出错也继续轮询
        this.pollingTimer = window.setTimeout(() => {
          this.pollTasksStatus();
        }, 5000); // 出错后延长轮询间隔
      }
    } catch (error) {
      // 出错后也继续轮询
      this.pollingTimer = window.setTimeout(() => {
        this.pollTasksStatus();
      }, 5000);
    }
  };

  // 更新任务状态
  updateTaskStatus = (taskId, status, taskData = null) => {
    if (!taskId) return;

    const type = window.location.pathname.split('/').pop();

    // 只有当状态不是进行中且与上次提示的任务ID不同时才显示提示
    if (status !== 1 && this.lastNotifiedTaskId !== taskId) {
      // 更新用户余额
      userStore.getCoinBalance(); 
      if (status === 2) {
        setTimeout(
          () => {
            message.success('任务完成');
          },
          type === 'matting' ? 5000 : 0
        );
      } else {
        message.error('任务失败');
      }
      // 更新上次提示的任务ID
      this.lastNotifiedTaskId = taskId;
    }

    runInAction(() => {
      const taskIndex = this.taskList.findIndex(task => task.id_str === taskId);

      if (taskIndex !== -1) {
        // 处理封面为空的情况
        let processedTaskData = taskData ? { ...taskData } : {};
        // 创建更新后的任务对象
        const updatedTask = {
          ...this.taskList[taskIndex],
          status,
          ...processedTaskData,
        };
        // 如果更新后的任务没有封面，设置biz_type
        if (!updatedTask.cover) {
          updatedTask.biz_type = 'text_image';
        }

        // 更新任务列表
        this.taskList = [
          ...this.taskList.slice(0, taskIndex),
          updatedTask,
          ...this.taskList.slice(taskIndex + 1),
        ];

        // 如果更新的是当前活动任务，也更新视频结果
        if (this.activeTaskId === taskId && processedTaskData?.data) {
          try {
            this.imageResult = JSON.parse(processedTaskData.data);
          } catch (e) {
            console.error('解析任务数据失败:', e);
          }
        }
      }
    });
  };

  // 添加新任务
  addNewTask = taskData => {
    if (!taskData || !taskData.id_str) return;

    runInAction(() => {
      // 将新任务添加到列表开头
      this.taskList = [taskData, ...this.taskList];
      // 设置为当前活动任务
      this.activeTaskId = taskData.id_str;
      // 如果有数据，更新视频结果
      if (taskData.data) {
        try {
          this.imageResult = JSON.parse(taskData.data);
        } catch (e) {
          console.error('解析新任务数据失败:', e);
          this.imageResult = null;
        }
      } else {
        this.imageResult = null;
      }
      sendBroadcast('work-task-changed');
      stateStore.setTaskUpdate(true);
    });

    // 如果是进行中的任务，添加到轮询列表并启动轮询
    if (taskData.status === 1) {
      // 添加到轮询列表
      this.pollingTaskIds.add(taskData.id_str);

      // 使用统一的方法启动轮询
      this.startPollingTasks();
    }
  };

  cancelTask = () => {
    const path = window.location.pathname;
    const segments = path.split('/').filter(Boolean);
    const formType = segments.pop();
    appLogger.log({
      key: 'aibot_photo_edit',
      action: 'click',
      arrt: logArrts[formType],
      type: 'cancel_task_preview',
      task_id: this.activeTask?.biz_id,
    });
    const item = this.activeTask;
    request
      .post(
        '/task/cancel?appsource=so&device_platform=Web',
        { id_str: item.id_str },
        {
          // @ts-ignore
          dataIsJson: true,
        }
      )
      .then(res => {
        if (res.data.result === 'finish') {
          this.pollingTaskIds.delete(item.id_str);
          // 更新剩余次数
          // this.refreshRemainingCounts();
          const taskIndex = this.taskList.findIndex(
            task => task.id_str === item.id_str
          );
          if (taskIndex !== -1) {
            runInAction(() => {
              // 从列表中删除任务
              this.taskList = [
                ...this.taskList.slice(0, taskIndex),
                ...this.taskList.slice(taskIndex + 1),
              ];
              this.setActiveTask(null, this.taskType);
              this.setHistoryActiveTask(this.taskType, null);
            });
          }
        } else {
          message.error(res.data.msg || '取消任务失败');
        }
      })
      .catch(error => {
        message.error('取消任务失败');
      });
  };

  onActiveTaskChange = item => {
    const action = JSON.parse(item?.data || '{}')?.edit_img_action;
    const targetTaskType = OperationTypeMap[action];
    const path = window.location.pathname;
    const segments = path.split('/').filter(Boolean);
    const formType = segments.pop();
    appLogger.log({
      key: 'aibot_photo_edit',
      action: 'click',
      arrt: logArrts[formType],
      type: 'click_task',
      task_id: item?.biz_id,
    });

    const map = {
      sharpen: () => {
        sharpenStore.setImgUrl(imgResult.image);
      },
      matting: () => {
        mattingStore.setImgUrl(imgResult.image);
      },
      expand: () => {
        expandStore.setImgUrl(imgResult.image);
      },
      erase: () => {
        EraseCanvasStore.setEraseForm({
          refer_img: imgResult.image,
        });
      },
      repaint: () => {
        RepaintCanvasStore.setRepaintForm({
          refer_img: imgResult.image,
        });
      },
    };

    this.setSource('task');
    this.setActiveTask(item, item?.biz_type);

    const imgResult = JSON.parse(item.data);

    map[targetTaskType]?.();

    stateStore.setLocation(`/generate/image/${targetTaskType}`);
  };
}

export const ModifyImageStore = new Store();
